// extracted by css-extract-rspack-plugin
export default {"sessionLabelCode":"PermissionDisplay-module__sessionLabelCode__OppmZ","detail":"PermissionDisplay-module__detail__b2yIe"};